import React, {Fragment, useState} from 'react'
import { useTranslation } from 'react-i18next'
import { currentLang } from '../../../utils/functions'
import Image from '../Image'
import ProductCard from '../ProductCard';

function ProductHighlight({items}) {
    const { t } = useTranslation();
    //console.log(items);
    return (
        <section className="module__product-highlight p-30 bg--gray-light">
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-12 col-xxl-10">
                    <div className="row justify-content-center">
                        {items && items.map((product, index)=>{
                            return (
                                <div className="col-sm-6 col-md-6 col-xl-3"><ProductCard key={index} data={product} /></div>
                            )
                        })}
                    </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ProductHighlight
